import { SecurityConfirm } from 'components'
import NovoColaborador from './NovoColaborador'
import ResumoColaborador from './ResumoColaborador'
import Comission from '../Captacao/Comission'

export const newGestor: any = [
  [<NovoColaborador key="novo-colaborador" />],
  [<ResumoColaborador key="resumo-colaborador" />],
  [<SecurityConfirm hasButtonBack key="security-confirm" />],
]

export const comission: any = [
  [
    <Comission key="commission" />,
    'Gestão de colaboradores > Novo Colaborador',
    (): void => {
      console.log('avançar 1')
    },
    (): void => {
      console.log('voltar 1')
    },
  ],
  [
    <div key="2">2</div>,
    'Gestão de colaboradores > Novo Colaborador',
    (): void => {
      console.log('avançar 2')
    },
    (): void => {
      console.log('voltar 2')
    },
  ],
]
